export const UsersGroup = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="8" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
<circle cx="24" cy="7" r="4" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="16" r="4" stroke="currentColor" stroke-width="2"/>
<path d="M22 30V28C22 25.7909 20.2091 24 18 24H14C11.7909 24 10 25.7909 10 28V30" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M30 23V19C30 16.7909 28.2091 15 26 15H24" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M2 23V19C2 16.7909 3.79086 15 6 15H8" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
